import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

// A list view setting (search, filter, layout) kept in this browser for this
// user and company, so the list opens as it was left. Storage can be missing
// or full: then the setting simply lasts until the page is left.
export default function useRememberedState(name, initial) {
  const { user } = useAuth();
  const key = `autotu:view:${user?.tenant_id || "-"}:${user?.id || "-"}:${name}`;
  const [value, setValue] = useState(() => {
    try {
      const saved = window.localStorage.getItem(key);
      return saved === null ? initial : JSON.parse(saved);
    } catch {
      return initial;
    }
  });
  // Only a changed setting is stored: the default leaves nothing behind.
  const serialized = JSON.stringify(value), fallback = JSON.stringify(initial);
  useEffect(() => {
    try {
      if (serialized === fallback) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, serialized);
    } catch { /* not remembered */ }
  }, [key, serialized, fallback]);
  return [value, setValue];
}
